import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@core/guard/auth.guard';
import { LayoutDefaultComponent } from '@core/layout/default/default.component';
import { LayoutPassportComponent } from '@core/layout/passport/passport.component';
import { Exception404Component } from '@shared/components/error/404.component';
import { Exception403Component } from '@shared/components/error/403.component';
import { Exception500Component } from '@shared/components/error/500.component';
import { HomeComponent } from './modules/home/components/home.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: LayoutPassportComponent,
    children: [
      {
        path: '',
        loadChildren: './modules/security/authentication.module#AuthenticationModule',
      },
    ],
  },
  {
    path: '',
    component: LayoutDefaultComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'home',
        component: HomeComponent,
        data: {
          title: 'Home',
        },
        canActivateChild: [AuthGuard],
      },
      {
        path: 'autonomous',
        loadChildren: './modules/autonomous/autonomous.module#AutonomousModule',
      },
      {
        path: 'contracts',
        loadChildren: './modules/contracts/contracts.module#ContractsModule',
      },
      {
        path: 'receipts',
        loadChildren: './modules/receipts/receipts.module#ReceiptsModule',
      },
      {
        path: 'informes',
        loadChildren: './modules/informes/informes.module#InformesModule',
      },
    ],
  },
  {
    path: 'error/403',
    component: Exception403Component,
  },
  {
    path: 'error/404',
    component: Exception404Component,
  },
  {
    path: 'error/500',
    component: Exception500Component,
  },
  {
    path: '**',
    component: Exception404Component,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
